import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Empty, Modal, Row, Table } from "antd";
import { useContext, useState } from "react";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";
import { ActividadCronograma } from "../../../../models/Maestras/maestras.model";
import { openNotification } from "../../../../utils/Notifactions";
import { TemplateContext } from "../../../../utils/template_context";

interface IModalActividades {
    openModal: boolean,
    setOpenModal: Function,
    isEdit: boolean,
    actividadesCronograma: ActividadCronograma[],
    obtenerCronogramaActividades: Function,
    datos: ActividadCronograma,
    setDatos: Function
}


export const ModalActividades = ({ openModal, setOpenModal, isEdit, actividadesCronograma, obtenerCronogramaActividades, datos, setDatos }: IModalActividades) => {
    const onCancel = () => {
        setOpenModal(false)
        setActividad({
            id: 0,
            nombre: '',
            fecha_actualizacion: '',
            fecha_creacion: ''
        })
    }
    const context = useContext(TemplateContext);
    const [actividad, setActividad] = useState<ActividadCronograma>({
        id: 0,
        nombre: '',
        fecha_actualizacion: '',
        fecha_creacion: ''
    })


    const addActividad = async () => {
        if (actividad.nombre !== '') {
            try {
                const resp = await apiMaestras.crearActividadCronograma(actividad);
                actividad.nombre = '';
                if (!resp.ok) {
                    return openNotification({
                        titulo: "Error",
                        descripcion: resp.message,
                        placement: "bottomRight",
                    });
                }
                obtenerCronogramaActividades();
            } catch (error) {
                console.log(error);
            }
        }
    }


    const [datosActividad, setDatosActividad] = useState<ActividadCronograma>({
        id: 0,
        nombre: '',
        fecha_actualizacion: '',
        fecha_creacion: ''
    })
    const [modalVisible, setModalVisible] = useState(false);
    const editActividad = (datos: ActividadCronograma) => {
        setDatosActividad(datos);
        setModalVisible(true);
    }

    const deleteActividad = async (datos: ActividadCronograma) => {
        try {

            const resp = await apiMaestras.eliminarActividadCronograma(datos.id);
            if (!resp.ok) {
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                });
            }
            obtenerCronogramaActividades();
        } catch (error) {
            console.log(error);
        }
    }


    const actualizarActividad = async () => {
        try {
            const resp = await apiMaestras.actualizarActividadCronograma(datosActividad);
            if (!resp.ok) {
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                });
            }
            obtenerCronogramaActividades();
            setModalVisible(false)
        } catch (error) {
            console.log(error);
        }
    }

    const guardarTodo = () => {
        obtenerCronogramaActividades();
        setOpenModal(false);
        setActividad({
            id: 0,
            nombre: '',
            fecha_actualizacion: '',
            fecha_creacion: ''
        })
    }

    const guardarEdicion = async () => {
        try {

            const resp = await apiMaestras.actualizarActividadCronograma(datos);
            if (!resp.ok) {
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                });
            }
            obtenerCronogramaActividades();
            setOpenModal(false)
        } catch (error) {
            console.log(error);
        }
    }

    const columns: any = [
        {
            title: "Nombre actividad cronograma",
            key: "nombre",
            dataIndex: "nombre",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg" ? "right" : false,
            render: (datos: ActividadCronograma) => (
                <div className="controls">
                    <EditOutlined onClick={() => editActividad(datos)} />
                    <DeleteOutlined onClick={() => deleteActividad(datos)} />
                </div>
            )
        },
    ]


    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar actividad cronograma</div>
                            )
                            :
                            (

                                <div>Crear actividad cronograma</div>
                            )
                        }
                    </>
                }
                visible={openModal}
                onCancel={onCancel}
                width={1000}
                footer={
                    <>
                        {isEdit
                            ?
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarEdicion}>Guardar y Finalizar</Button>
                                    </Col>
                                </Row>
                            )
                            :
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarTodo}>Cerrar</Button>
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
            >
                {isEdit
                    ?
                    (
                        <Row>
                            <Col span={24}>
                                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                    Nombre actividad cronograma
                                </span>
                                <InputTexto
                                    name="nombre"
                                    texto={datos.nombre}
                                    setTexto={setDatos}
                                    alltexto={datos}
                                />
                                {/* <Input value={datos.nombre} onChange={(e) => setDatos({ ...datos, nombre: e.target.value })} /> */}
                            </Col>
                        </Row>
                    )
                    :
                    (
                        <>
                            <Row>
                                <Col span={24}>
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Nombre actividad cronograma
                                    </span>
                                    <InputTexto
                                        name="nombre"
                                        texto={actividad.nombre}
                                        setTexto={setActividad}
                                        alltexto={actividad}
                                    />
                                    {/* <Input value={actividad.nombre} onChange={(e) => setActividad({ ...actividad, nombre: e.target.value })} /> */}
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col>
                                    <Button className="button-azul-radius" onClick={addActividad}>Guardar</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div>Actividades creadas</div>
                                </Col>
                                <Col>
                                    <Table
                                        dataSource={actividadesCronograma}
                                        columns={columns}
                                        locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                        style={{ borderTop: "1px solid #C4C4C4" }}
                                        size="small"
                                        bordered={false}
                                        pagination={false}
                                        scroll={{ x: 1500, y: 300 }}
                                    />
                                </Col>
                            </Row>
                        </>
                    )
                }
            </Modal>
            {modalVisible &&
                <Modal
                    title="Editar actividad"
                    visible={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    width={1000}
                    footer={
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button className="button-blanco-radius" onClick={() => setModalVisible(false)}>Cancelar</Button>
                            </Col>
                            <Col>
                                <Button className="button-azul-radius" onClick={actualizarActividad}>Guardar Cambios</Button>
                            </Col>
                        </Row>
                    }
                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre actividad cronograma
                            </span>
                            <InputTexto
                                name="nombre"
                                texto={datosActividad.nombre}
                                setTexto={setDatosActividad}
                                alltexto={datosActividad}
                            />
                            {/* <Input value={datosActividad.nombre} onChange={(e) => setDatosActividad({ ...datosActividad, nombre: e.target.value })} /> */}
                        </Col>
                    </Row>

                </Modal>
            }
        </>
    )
}
